<template>
    <div class="flex flex-row justify-between w-full">
        <p class="text-[#09090B] font-inter text-lg font-semibold leading-7">Verify Phone</p>
        <!-- <div class="flex justify-center items-center rounded-lg text-[#A4A7AE] cursor-pointer" @click="close">
            <XMarkIcon class="h-[24px] w-[24px]" />
        </div> -->
    </div>
    <div class="self-stretch">
        <p class="text-[#535862] text-sm font-normal leading-5 font-inter">
            Enter the verification code sent to the below phone number to add it to your Identity Vault. We'll start scanning for
            exposures linked to it.
            <span class="block mt-1">
                Phone:
                <span class="font-bold"> {{ data.country_code }} {{ data.phone_number }}</span>
            </span>
        </p>
    </div>
</template>
<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
import { ModalNames } from '~/types/modals';

const emit = defineEmits(['closeDialog']);

const close = () => {
    emit('closeDialog');
};

//dialolg ref data
const dialogRef =   getDialogRef(ModalNames.PHONE_VERIFICATION);
const data = dialogRef.value.data;
</script>
